import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Grid,
    FormControlLabel,
    Checkbox
} from '@material-ui/core';

import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// utils
import DateFnsUtils from '@date-io/date-fns';
import startOfToday from 'date-fns/startOfToday';
import subDays from 'date-fns/subDays';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    label: {
        marginLeft: '0px'
    },
    greyedLabel: {
        marginLeft: '0px',
        color: 'rgba(0, 0, 0, 0.3)'
    },
});



class FormFieldDataScadenza extends Component {

    render() {
        const { classes, hasScadenza, value, helperText, setScadenza, onDataScadenzaChange } = this.props;

        return (
            <Grid container spacing={2}>
                <Grid item xs={4} sm={4} className={classes.alignLeft}>
                    <FormControlLabel className={hasScadenza === true ? classes.greyedLabel : classes.label }
                        control={
                            <Checkbox
                                checked={!hasScadenza}
                                onChange={e => setScadenza(!e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Nessuna scadenza"
                    />
                </Grid>
                <Grid item xs={8} sm={8}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            value={value}
                            disabled={!hasScadenza}
                            disableToolbar
                            variant="inline"
                            inputVariant="outlined"
                            format="dd/MM/yyyy"
                            minDate={subDays(startOfToday(), 1)}
                            margin="normal"
                            onChange={date => onDataScadenzaChange(date)}
                            KeyboardButtonProps={{ 'aria-label': 'change date' }}
                            InputAdornmentProps={{ position: "start" }}
                            helperText={helperText}
                            error={helperText !== '' ? true : false}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>
        );
    }
}

FormFieldDataScadenza.propTypes = {
    onDataScadenzaChange: PropTypes.func.isRequired,
    setScadenza: PropTypes.func.isRequired,

    hasScadenza: PropTypes.bool.isRequired,

    value: PropTypes.instanceOf(Date),
    helperText: PropTypes.string.isRequired,
};

export default withStyles(styles)(FormFieldDataScadenza);